import React, { useState, useEffect } from 'react';

import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import SinPermisos from '../../Components/SinPermisos/SinPermisos';

import AjusteInventarioData from '../../Components/Admin/AjusteInventarioData/AjusteInventarioData';

import { fetchUsuario, getUsuario } from '../../Components/user';

export default function AjusteInventario() {

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();

    return (
        <div className='containerGrid'>

            <Header />

            <section className='containerSection'>

                <HeaderDash />

                <div className='container'>

                    {loading ? (
                        <></>
                    ) : usuarioLegued?.idUsuario ? (
                        <>
                            {usuarioLegued?.rol === 'admin' ? (
                                <AjusteInventarioData />
                            ) : usuarioLegued?.rol === 'colaborador' ? (
                                <AjusteInventarioData />
                            ) : (
                                <SinPermisos />
                            )}
                        </>
                    ) : (
                        <AjusteInventarioData />
                    )}

                </div>

            </section>

        </div>
    );
}